<template>
  <div>
    <!-- 설명 -->
    <p class="mb-5" style="color: #4839EB;">{{ $t('※ 8대 위험요인(사다리/비계, 지붕, 고소작업대, 방호장치, 혼재작업, 충돌방지 장치, LOTO)에 대한 위험성은 필히 반영') }}</p>

    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['com_name', 'field_name', 'date',]"
      :mobile-types="['field_name']"
      :typeslabel="{
        com_name: '회사명',
      }"
    />

    <!--    위험성평가 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>{{ $t('위험성평가 정보') }}</h5>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('평가대상') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input v-else v-model="form.inputA_1" :readonly="board.readonly"/>
        </div>
        <div>
          <div>{{ $t('평가자(대표)') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" :readonly="board.readonly"/>
        </div>
        <div>
          <div>{{ $t('평가자(근로자)') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <ml-input v-else v-model="form.inputA_3" :readonly="board.readonly"/>
        </div>

        <div>
          <div>{{ $t('평가일') }}</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_4 }}</p>
          <date-selector v-model="form.inputA_4" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 정기 위험성 평가 -->
    <table-risk-appraisal584
      class="mt-5"
      title="정기 위험성 평가"
      v-model="form.riskAppraisalList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      :hide-code-number="true"/>

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import MeasureStateSelector from "@/components/selector/MeasureStateSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import TableRiskAppraisal584 from "@/views/boards/single-page/584/TableRiskAppraisal584.vue";

export default {
  components: {
    TableRiskAppraisal584,
    TableCustom,
    SignField,
    PhotoUploadGridModule,
    FieldSelectModule,
    MeasureStateSelector,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    'form.riskAppraisalList': {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.disasterList = value.map((item) => item.input_3);
        this.form.disasterString = this.form.disasterList.toString()
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",

        riskAppraisalList: [
          {
            "id": 0,
            "input_check": false,
            "input_1": "사다리 사용 작업",
            "input_2": "불규칙한 바닥, 경사로 등 불안전한 장소에서 작업 중 사다리가 기울어 지며 떨어짐 발생 위험",
            "input_3": "",
            "input_4": "상",
            "input_5": "",
            "input_6": "",
            "input_7": "",
            "input_8": ""
          },
          {
            "id": 1,
            "input_check": false,
            "input_1": "사다리 사용 작업",
            "input_2": "사다리 위에서 작업 중 과도한 힘이나 중심 이동으로 사다리가 기울어 지거나 넘어지며 떨어짐 발생 위험\n(배선을 당기거나, 관통/설치 작업 등)",
            "input_3": "",
            "input_4": "상",
            "input_5": "",
            "input_6": "",
            "input_7": "",
            "input_8": ""
          },
          {
            "id": 2,
            "input_check": false,
            "input_1": "사다리 사용 작업",
            "input_2": "높이별 사다리 사용 작업 기준을 지키지 않아 떨어짐 발생 위험",
            "input_3": "",
            "input_4": "상",
            "input_5": "",
            "input_6": "",
            "input_7": "",
            "input_8": ""
          }
        ],

        fileList: [],

        disasterList: [],
        disasterString: "",
      },
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
